import React from 'react'

import { version } from '../../../package.json'

const VersionIndicator = () => (
  <p style={{ color: 'lightgray', position: 'fixed', top: 10, right: 15 }} className='pull-right'>
    {version}
  </p>
)

export default VersionIndicator



// WEBPACK FOOTER //
// ./src/components/VersionIndicator/VersionIndicator.js